import { useEffect, useState } from "react"
import { getProvince, getCities } from "../../api/CityService"
import { InputError, LightTooltip } from '../utils';
import { Controller } from 'react-hook-form';
import Select from 'react-select'

export const CitySelect = ({control,watch, hasError, disable}) => {

    const[provinces, setProvinces] = useState('')
    const[cities, setCities] = useState('')
    const [firstTimeP, setFirstTimeP] = useState(true)
    const [firstTimeC, setFirstTimeC] = useState(true)

    const province = watch("province");

    useEffect(() => {
        if(province){
            let cityInfo  = getCities(province?.value);
            if(cityInfo){
                let optionsCity = cityInfo.map((item) => ({
                    value: item.name,
                    label: item.name,
                }));
                setCities(optionsCity)
            }
        }

    },[province])

    useEffect( () => {
        let provincesInfo = getProvince();
            let optionsprovinces = provincesInfo.map((item) => ({
                value: item.name,
                label: item.name,
            }));
            setProvinces(optionsprovinces)

    }, [])

    return(
        <>
            <div className='row justify-content-center mt-2'>
                <div className='col-12 col-md-5'>

                    <label className="form-label text-form-title"
                    >استان محل اقامت</label>
                    <span className='required-label'>
                        *
                    </span>

                    <LightTooltip tooltip_title={'استان محل اقامت'} />

                    <Controller
                        name='province'
                        control={control}
                        rules={{ required: "استان محل اقامت خود را انتخاب کنید." }}
                        render={({ field , fieldState: {invalid, error}}) => (

                            <>
                                <Select
                                    {...field}
                                    options={provinces ? provinces : []}
                                    isDisabled={disable}
                                    onChange={ (e) => {
                                        if(!disable) {
                                            field.onChange(e)
                                            setFirstTimeP(false)
                                        }
                                    }}
                                    placeholder={'استان خود را انتخاب کنید.'}
                                    clearable={false}
                                    // value={field.value ? {value:field.value, label:field.value} : null}
                                    styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderRadius: 5,
                                        borderColor: state.isFocused ?
                                            '#044448' : error || (firstTimeP && hasError) == 'error' ?
                                                "red" : (firstTimeP && hasError) =='correct' ?
                                                    '#54ac12' : provided.borderColor,
                                        fontFamily: "IRANYekanX"
                                    }),
                                    placeholder: (provided, state) => ({
                                        ...provided,
                                        fontSize: '1rem', // Set the font size for the placeholder
                                      }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#044448' : provided.backgroundColor,
                                        color: state.isFocused ? 'white' : provided.color,
                                        borderRadius: 5,
                                        fontFamily: "IRANYekanX"
                                    }),
                                    menuList: (base) => ({
                                        ...base,
                                        "::-webkit-scrollbar": {
                                        width: "6px",
                                        height: "0px",

                                        },
                                        "::-webkit-scrollbar-track": {
                                        background: "#f1f1f1"
                                        },
                                        "::-webkit-scrollbar-thumb": {
                                        background: "#044448",
                                        borderRadius: "15px"
                                        },
                                        "::-webkit-scrollbar-thumb:hover": {
                                        background: "#555"
                                        }
                                    })
                                    }}
                                />
                                {error && ( <InputError message={error.message} show={true}/> )}
                            </>

                        )}
                    />

                </div>
            </div>

            <div className='row justify-content-center mt-4'>
                <div className='col-12 col-md-5'>

                    <label className="form-label text-form-title"
                    >شهر محل اقامت</label>
                    <span className='required-label'>
                         *
                     </span>

                    <LightTooltip tooltip_title={'شهر محل اقامت'} />

                    <Controller
                        name='city'
                        control={control}
                        rules={{ required: 'شهر محل اقامت خود را انتخاب کنید.' }}
                        render={({ field , fieldState: {invalid, error}}) => (

                            <>
                                <Select
                                    {...field}
                                    options={cities ? cities : []}
                                    isDisabled={disable}
                                    onChange={ (e) => {
                                        if(!disable) {
                                            field.onChange(e)
                                            setFirstTimeC(false)
                                        }

                                    }}
                                    placeholder={'شهر خود را انتخاب کنید.'}
                                    clearable={false}
                                    styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderRadius: 5,
                                        borderColor: state.isFocused ?
                                            '#044448' : error || (firstTimeC && hasError) == 'error' ?
                                                "red" : (firstTimeC && hasError) =='correct' ?
                                                    '#54ac12' : provided.borderColor,
                                        fontFamily: "IRANYekanX"
                                    }),
                                    placeholder: (provided, state) => ({
                                        ...provided,
                                        fontSize: '1rem', // Set the font size for the placeholder
                                        fontWeight: '400'
                                      }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#044448' : provided.backgroundColor,
                                        color: state.isFocused ? 'white' : provided.color,
                                        borderRadius: 5,
                                        fontFamily: "IRANYekanX"
                                    }),
                                    menuList: (base) => ({
                                        ...base,
                                        "::-webkit-scrollbar": {
                                        width: "6px",
                                        height: "0px",

                                        },
                                        "::-webkit-scrollbar-track": {
                                        background: "#f1f1f1"
                                        },
                                        "::-webkit-scrollbar-thumb": {
                                        background: "#044448",
                                        borderRadius: "15px"
                                        },
                                        "::-webkit-scrollbar-thumb:hover": {
                                        background: "#555"
                                        }
                                    })
                                    }}
                                />
                                {error && ( <InputError message={error.message} show={true}/> )}
                            </>

                        )}
                    />

                </div>
            </div>
        </>

    )
}